<template>
  <!-- 后台管理模块父组件PC端设计 -->
  <div class="modul-PC" >这里是PC端设计</div>
</template>

<script>
import editFormheader from "@/components/components/editFormheader";
// / 引用公共的导航栏组件
import PublicNavBar from "@/components/public/NavBar";
// 引用左侧基础组件sliderassembly
import sliderassembly from "@/components/components/sliderassembly";
import utils from "@/utils/index"; // 方法类
import componentProperties from "@/utils/componentProperties"; // 组件数据
import html2canvas from "html2canvas"; // 生成图片
import FileSaver from "file-saver"; // 导出JSON

export default {
  name: "moduleIndexPC",
  inject: ["reload"],
  components: {
    sliderassembly,
    PublicNavBar,
    editFormheader,
  },
  data() {
    return {
      activeIndex: 0,
      activeNavbarIndex: 0,
      horizontalWidth: "63%",
      navbarList: [
        { label: "微官网", path: "" },
        { label: "PC端官网", path: "" },
      ],
      realTimeView: {
        show: false, // 是否显示预览
      },
      id: null, //当前页面
      deleShow: true, //删除标签显示
      index: "", //当前选中的index
      rightcom: "decorate", //右侧组件切换
      currentproperties: {}, //当前属性
      decorateWidth: 0, // 右侧面板宽度，用于弹出动画
      isHeaderSelected: false, // 头部导航栏选中状态
      pageSetup: {
        // 页面设置属性
        // title: "顶部标题", //页面名称
        // leftContent: "", //左侧自定义内容（文本或简单HTML，复杂内容用 left 插槽）
        // rightContent: "", //右侧按钮文本
        // showLeftArrow: false, // 是否显示左侧返回箭头（默认左箭头优先级低于 left 插槽）
        // showBorder: true, // 是否显示底部边框
        // // fixed: true, // 是否固定在顶部
        // navbarBackground: "#876545", //导航栏背景颜色
        name: "页面标题", //页面名称
        details: "", //页面描述
        titleHeight: 50, // 高度
        enterpriseName: "企业名称",
        customColor: "rgba(31, 241, 199, 1)", //自定义颜色
        details: "", //页面描述
        isPerson: false, // 是否显示个人中心
        isBack: true, // 是否返回按钮
        bgColor: "rgba(249, 249, 249, 10)", //背景颜色
        bgImg: "", // 背景图片
      },
      pageComponents: [], //页面组件
      offsetY: 0, //记录上一次距离父元素高度
      pointer: { show: false }, //穿透
      onlyOne: ["1-5", "1-16"], // 只能存在一个的组件(组件的type)
      selectedIndex: -1, // 当前选中的组件索引
      selectedComponent: {}, //当前选中的组件名称
      seletedActiveTop: 0,
      // 当前活动的菜单索引，用于高亮显示
      currentActiveIndex: "1", // 默认选中"模块"菜单项
      isSidebarOpen: true, // 控制侧边栏显示/隐藏的状态
    };
  },

  mounted() {
    this.currentproperties = this.pageSetup;
  },

  methods: {},

  watch: {
    /* 监听右侧属性设置切换 */
    rightcom(newval) {
      if (newval === "decorate") {
        utils.forEach(this.pageComponents, (res) => {
          /* 修改选中 */
          if (res.active === true) res.active = false;
        });
        this.currentproperties = this.pageSetup;
        return;
      }
      if (newval === "componenmanagement") {
        /* 替换 */
        utils.forEach(this.pageComponents, (res) => {
          /* 修改选中 */
          if (res.active === true) res.active = false;
        });
        this.currentproperties = this.pageComponents;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pointer-events {
  pointer-events: none;
}

.modul-PC {
  width: 100%;
  height: 100%;

  /* 删除组件 */
  .deles {
    position: absolute;
    min-width: 80px;
    text-align: center;
    line-height: 25px;
    background: #fff;
    height: 25px;
    font-size: 12px;
    right: -87px;
    cursor: pointer;
    .icon-sanjiaoxingzuo {
      position: absolute;

      left: -11px;
      color: #fff;
      font-size: 12px;
      top: 50%;
      transform: translateY(-50%);
    }
    &:hover {
      i {
        display: block;
        position: absolute;
        left: 0;
        font-size: 16px;
        top: 0;
        text-align: center;
        line-height: 25px;
        width: 100%;
        color: #fff;
        height: 100%;
        z-index: 10;
        background: rgba(0, 0, 0, 0.5);
      }
      .icon-sanjiaoxingzuo {
        color: rgba(0, 0, 0, 0.5);
      }
    }

    i {
      display: none;
    }
  }

  /* 按钮集合 */
  .buttons {
    border-bottom: 1px solid #ebedf0;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding-right: 15px;
    align-items: center;
    /* 下拉 */
    .frop {
      padding-right: 15px;
      .el-button.el-button--primary.el-dropdown-selfdefine {
        background: #fff;
        color: #000;
        border: 1px solid #dcdee0;
      }
    }
    .el-button {
      font-size: 14px;
      padding: 0 16px;
      height: 30px;
      &.el-button--primary {
        background: #155bd4;
      }
      &.el-button--danger {
        background: red;
      }
    }
  }

  /* 操作主体 */
  .modul-operation {
    width: 100%;
    height: calc(100vh - 65px);
    display: flex;
    flex-direction: row;

    // 左侧导航栏容器样式
    .sidebar-container {
      height: 100%;
      flex-shrink: 0;
    }

    // 调整其他元素的宽度以适应新的侧边栏
    .phone {
      flex: 1;
      height: 100%;
      // overflow-y: scroll;
      display: flex;
      justify-content: center;
      background: #f7f8fa;
      &::-webkit-scrollbar {
        width: 1px;
      }
      // &::-webkit-scrollbar-thumb {
      //   background-color: #155bd4;
      // }
      .headerTop {
        position: relative;
        transition: all 0.3s ease;
        cursor: pointer;
      }
      .headerTop:hover {
        // border: 1px dotted rgb(21, 91, 212);
      }
      .header-selected {
        border: 1px solid rgb(21, 91, 212) !important;
      }

      /* 手机样式 */
      .phoneAll {
        width: 375px;
        height: 400px;
        height: calc(100vh - 250px);
        overflow: scroll;
        &::-webkit-scrollbar {
          //隐藏原生滚动轴
          width: 1px;
        }
        // min-height: 760px;
        box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.1);
        // margin: 15px 0 0 0;
        position: relative;
        padding-bottom: 50px;

        /* 手机高度 */
        .phoneSize {
          position: absolute;
          left: -137px;
          top: 640px;
          font-size: 12px;
          color: #a2a2a2;
          border-bottom: 1px solid #dedede;
          width: 130px;
          height: 21px;
          line-height: 21px;
        }
        .phoneBottom {
          border: 3px solid red;
          margin-top: -30px;

          // position: absolute;
          // left: -137px;
          // top: 660px;
          // font-size: 12px;
          // color: #a2a2a2;
          // border-bottom: 1px solid #dedede;
          // width: 130px;
          // height: 21px;
          // line-height: 21px;
        }

        /* 状态栏 */
        .statusBar {
          width: 100%;
          display: block;
        }

        /* 主体内容 */
        .phone-container {
          min-height: 367px;
          box-sizing: border-box;
          cursor: pointer;
          width: 100%;
          position: relative;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          .componentsClass {
            border: 1px solid #fff;
            &:hover {
              border: 1px dashed #155bd4;
            }
          }
        }
      }
    }
  }
  /* 左侧抽屉相关样式 */
  .toggle-sidebar-btn-container {
    position: relative;
    .toggle-sidebar-btn {
      cursor: pointer;
      position: absolute;
      width: 100px;
      height: 50px;
      background: #e5f1ff;
      box-sizing: border-box;
      border: 1px solid #ffffff;
      color: #348cf8;
      line-height: 50px;
      text-align: center;
    }
    .toggle-sidebar-btn.open {
      left: 0;
      top: 300px;
      border-radius: 0px 38px 38px 0px;
    }
    .toggle-sidebar-btn.close {
      right: 0;
      top: 650px;
      border-radius: 38px 0 0 38px;
    }
  }

  .sidebar-container {
    // position: fixed;
    // left: 0;
    // top: 0;
    // bottom: 0;
    // width: 300px;
    background-color: #fff;
    // z-index: 1000;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
    // overflow-y: auto;
  }

  /* 左侧抽屉过渡动画 */
  .sidebar-slide-enter-active,
  .sidebar-slide-leave-active {
    transition: all 0.3s ease;
  }

  .sidebar-slide-enter,
  .sidebar-slide-leave-to {
    transform: translateX(-100%);
  }

  /* 右侧工具栏 */
  .decorateAll {
    border: 3px solid green;
    width: 380px;
    height: 100%;
    // height: calc(100vh - 60px);
    overflow-y: scroll;
    overflow-x: hidden;
    position: relative;
    padding: 0 12px;
    background: #fff;
    &::-webkit-scrollbar {
      width: 1px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #155bd4;
    }
  }

  /* 页面设置tab */
  .decorateTab {
    position: fixed;
    display: flex;
    right: 380px;
    top: 115px;
    flex-direction: column;
    span {
      background-color: #fff;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
      border-radius: 2px;
      width: 94px;
      height: 32px;
      display: inline-block;
      text-align: center;
      line-height: 32px;
      margin-bottom: 12px;
      transition: all 0.8s;
      cursor: pointer;
      &.active {
        background-color: #155bd4;
        color: #fff;
      }
      /* 图标 */
      i {
        font-size: 12px;
        margin-right: 5px;
      }
    }
  }
}
/* 动画 */
.decorateAnima-enter-active {
  transition: all 0.3s ease;
}
.decorateAnima-leave-active {
  transition: all 0.3s ease;
}
.decorateAnima-enter {
  transform: translate(8px, 8px);
  opacity: 0;
}
.decorateAnima-leave-to {
  transform: translate(8px, 8px);
  opacity: 0;
}
</style>
